import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status >= 500 || error.response.status === 401) {
            // Redirect to /login on server error
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refreshToken');
            if (!refreshToken) {
                return Promise.reject(error);
            }
            try {
                const response = await api.post('/auth/refresh-token', { refreshToken });
                if (response.status === 200) {
                    localStorage.setItem('token', response.data.accessToken);
                    api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.accessToken;
                    return api(originalRequest);
                }
            } catch (refreshError) {
                console.error('Refresh token error:', refreshError);
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default api;